{
    "actions": {
        "page": {
            "add_clients": "Add allowed clients",
            "create_plan": "New plan",
            "new_pos": {
                "block": "Block new POS",
                "unblock": "Unblock new POS"
            },
            "receive_alerts": "Receive alerts",
            "update_offer": "Update plan"
        },
        "row": {
            "delete_access": "Delete access",
            "parent_plans": {
                "delete": "Remove {{labelName}}"
            }
        }
    },
    "filter": {
        "placeholder": {
            "parent_subscription_label": "Filter by provider plan",
            "label": "Filter client plan label",
            "product_code": "Filter by client plan code",
            "organization": "Filter by organization name"
        }
    },
    "info": {
        "block_new_pos": "Blocking of new terminals is activated"
    },
    "keys": {
        "parent_subscription_label": "Provider plan",
        "label": "Client plan label",
        "product_code": "Client plan code",
        "created_at": "Creation date",
        "updated_at": "Last updated on",
        "auto_activate": "Auto activate subscriptions",
        "auto_activate_short": "Auto activate",
        "auto_activate_alert": "Every new automatically registered subscriptions will be activated with this plan when calling the gateway."
    },
    "modal": {
        "add_allowed_clients": {
            "title": "Add allowed clients",
            "success": "Allowed client added successfully!"
        },
        "update_plan": {
            "title": "Update plan",
            "success": "Plan successfully updated!",
            "auto_activate": {
                "yes": "Yes",
                "no": "No",
                "warning": "This feature can only be enabled on a single plan. If you enable it for this plan, it will be disabled for the previous plan."
            }
        },
        "create_plan": {
            "title": "Add a plan",
            "steps": {
                "plan_selection": "Step {{step}} of {{maxStep}}: Select a privder plan",
                "form": "Step {{step}} of {{maxStep}}: Plan details"
            }
        },
        "block_new_pos": {
            "title": "Activate POS blocking",
            "warning": "You are about to activate blocking of new POS terminals.",
            "validate_question": "Do you want to continue?",
            "success": "Blocking new POS activated successfully!",
            "error": "Block new POS activation has failed"
        },
        "unblock_new_pos": {
            "title": "Deactivate POS blocking",
            "warning": "You are about to deactivate blocking of new POS terminals.",
            "validate_question": "Do you want to continue?",
            "success": "Blocking new POS deactivated successfully!",
            "error": "Block new POS deactivation has failed"
        },
        "update_subscription_plan": {
            "title": "Update plan",
            "text": "You have selected plan \"{{planLabel}}\" to update this offer.",
            "confirm": "Would you like to continue?",
            "success": "Plan updated successfully!",
            "error": "An error occurred while updating subscription.",
            "steps": {
                "select_plan": "Step {{step}} on {{maxStep}} : Select a plan",
                "confirm": "Step {{step}} on {{maxStep}} : Confirm plan update"
            }
        },
        "add_existing_plan": {
            "title": "Add an existing plan"
        }
    },
    "toast": {
        "success": {
            "delete_access": "Successful reactivation of the merchant account",
            "delete_allowed_client": "Customer has been successfully removed from the plan"
        },
        "error": {
            "delete_access": "Customer has been successfully removed from the plan",
            "CLIENT_ALREADY_ALLOWED": "One of the selected organizations is already a client of this plan",
            "SUBSCRIPTION_PLAN_ALREADY_ALLOWED": "One of the selected plans is already allowed for this organization",
            "SUBSCRIPTION_PLAN_IS_PARENT_OFFER": "This customer cannot be removed from this plan because it is used as a parent offer",
            "UNKNOWN_ERROR": "An unknown error occurred.",
            "ALREADY_EXISTS": "This product code is already used"
        }
    }
}